import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Star03 = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "star03",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M11.2896 3.3664c.2297-.4421.3446-.6632.4985-.735a.5.5 0 0 1 .4229 0c.1539.0718.2688.2929.4985.735l1.513 2.9122c.0991.1907.1486.286.2229.3494a.5.5 0 0 0 .2291.1104c.0959.0186.2013-.0022.4122-.0436l3.2202-.6328c.4889-.0961.7333-.1441.8854-.0686a.4998.4998 0 0 1 .2637.3307c.0398.1651-.0614.3927-.2638.848l-1.3336 2.9986c-.0873.1964-.131.2946-.1342.3921a.5005.5005 0 0 0 .0566.248c.0452.0865.1272.156.291.295l2.5026 2.1232c.3799.3223.5699.4834.6057.6495a.5003.5003 0 0 1-.0941.4123c-.1043.1341-.3454.1968-.8275.3224l-3.176.827c-.2079.0542-.3119.0813-.3902.1396a.4998.4998 0 0 0-.1585.1988c-.0395.0894-.0428.1968-.0493.4115l-.0996 3.2804c-.0151.498-.0227.747-.1302.8785a.5.5 0 0 1-.381.1835c-.1699.002-.3692-.1473-.768-.446l-2.6268-1.9674c-.172-.1288-.258-.1932-.3524-.218a.4982.4982 0 0 0-.2543 0c-.0944.0248-.1804.0892-.3524.218l-2.6268 1.9674c-.3988.2987-.5981.448-.768.446a.5.5 0 0 1-.381-.1835c-.1075-.1315-.115-.3805-.1302-.8785l-.0996-3.2804c-.0065-.2147-.0098-.3221-.0493-.4115a.5.5 0 0 0-.1585-.1988c-.0783-.0583-.1823-.0854-.3902-.1396l-3.176-.827c-.4821-.1256-.7232-.1883-.8275-.3224a.5.5 0 0 1-.094-.4123c.0357-.1661.2257-.3272.6056-.6495l2.5026-2.1232c.1638-.139.2458-.2085.291-.295a.5001.5001 0 0 0 .0566-.248c-.0032-.0975-.0469-.1957-.1342-.3921L4.8069 7.172c-.2024-.4552-.3036-.6828-.2638-.848a.5.5 0 0 1 .2637-.3306c.1521-.0755.3965-.0275.8854.0686l3.2203.6328c.2108.0415.3162.0622.412.0436a.5.5 0 0 0 .2292-.1104c.0743-.0633.1239-.1587.223-.3494l1.5129-2.9122Z"
    })
  }));
};
export default Star03;